export default function useOptimisticUpdate(items, setItems, showToast) {
  return async function applyUpdate(itemId, patch, apiFn, errorMsg) {
    const original = items.find((i) => i.id === itemId);
    setItems((prev) => prev.map((i) => (i.id === itemId ? { ...i, ...patch } : i)));
    try {
      const updated = await apiFn();
      setItems((prev) => prev.map((i) => (i.id === itemId ? updated : i)));
      return true;
    } catch (err) {
      if (original) setItems((prev) => prev.map((i) => (i.id === itemId ? original : i)));
      showToast(err.message || errorMsg, 'error');
      return false;
    }
  };
}
